import { render, staticRenderFns } from "./DashboardTooltip.vue?vue&type=template&id=4ab4828d"
import script from "./DashboardTooltip.vue?vue&type=script&lang=js"
export * from "./DashboardTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports